import React, { Component } from 'react'
import { Menu } from '../icons/index'
import sleep from '../../sleep'
import { Spring, Trail, Keyframes, animated, config } from 'react-spring'
import './_mobileMenu.scss'

class MobileMenu extends Component {
  constructor() {
    super()
    this.state = {
      menuOpen: false,
      links: [
        {
          name: 'Studio',
          url: 'http://cetraruddy.com/expertise',
          cssClass: ''
        },
        {
          name: 'Projects',
          url: 'http://cetraruddy.com/projects',
          cssClass: ''
        },
        {
          name: 'CR Celebrates',
          url: 'http://cetraruddy.com',
          cssClass: 'yellow'
        },
        {
          name: 'Media',
          url: 'http://cetraruddy.com/media',
          cssClass: ''
        },
        {
          name: 'Contact',
          url: 'http://cetraruddy.com/location',
          cssClass: ''
        }
      ]
    }
  }

  toggle = () => {
    this.setState({
      menuOpen: !this.state.menuOpen
    }, () => this.state.menuOpen ? this.animateIn() : this.animateOut())
  }

  animateIn = async () => {
    this.container(Spring, { from: { x: 120 }, to: { x: 0 }, config: config.slow })
    await sleep(100)
    await this.content(Trail, { from: { x: 120, opacity: 0 }, to: { x: 0, opacity: 1 } })
  }

  animateOut = async () => {
    this.content(Trail, { to: { x: 120, opacity: 0 } })
    await sleep(500)
    await this.container(Spring, { to: { x: 120 }, config: config.slow })
  }

  render() {
    const { links } = this.state
    return (
      <div className="mobile_menu">
        <span className="mobile_menu_button" onClick={this.toggle}><Menu /></span>
          <Keyframes native script={next => (this.container = next)}>
            {({ x }) => (
              <animated.div className="container" style={{ transform: x.interpolate(x => `translate3d(${x}%,0,0)`) }}>
                <Keyframes native keys={links} script={next => (this.content = next)}>
                  {links.map(link => ({ x, ...props }) => (
                    <animated.li
                      className={link.cssClass}
                      style={{ transform: x.interpolate(x => `translate3d(${x}%,0,0)`), ...props }}>
                      <a href={link.url} target="_blank" rel="noopener">
                        {link.name}
                      </a>
                    </animated.li>
                  ))}
                </Keyframes>
              </animated.div>
            )}
          </Keyframes>
      </div>
    )
  }
}

export default MobileMenu



// WEBPACK FOOTER //
// ./src/components/mobileMenu/index.js